import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withLastLocation} from 'react-router-last-location';

// PrimeReact components
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';

// Styles
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

class reorderShelfList extends Component {
    state = {
        shelves: null,
    };

    handleCancelClick = event => {
        const {cancelShelfOrder} = this.props;
        event.preventDefault();

        cancelShelfOrder();
    };

    handleSubmit = event => {
        const {updateShelfOrder} = this.props;
        const {shelves} = this.state;

        event.preventDefault();
        updateShelfOrder(shelves);
    };

    reorderShelfList(reorderedShelves) {
        this.setState({shelves: reorderedShelves});
    }

    render() {
        const {shelvesData} = this.props;
        const {shelves} = this.state;

        if (!shelves) {
            this.setState({shelves: shelvesData});
        }

        if (shelvesData) {
            return (
                <div>
                    <p style={{paddingLeft: '1em'}}>
                        To modify the shelves order, use drag and drop on the square control at each shelf row's
                        left-hand side.
                    </p>
                    <div className="p-d-flex p-flex-row">
                        <Button
                            icon="pi pi-chevron-left"
                            label="Back"
                            style={{marginLeft: '1em'}}
                            onClick={event => {
                                this.handleCancelClick(event);
                            }}
                        />
                        <Button
                            label="Save Changes"
                            style={{marginLeft: '1em'}}
                            onClick={event => {
                                this.handleSubmit(event);
                            }}
                        />
                    </div>
                    <DataTable
                        reorderableColumns={true}
                        reorderableRows={true}
                        style={{padding: '1em', marginTop: '1em'}}
                        value={shelves}
                        onRowReorder={e => this.reorderShelfList(e.value)}
                    >
                        <Column rowOrderIcon="e95f" rowReorder={true} style={{width: '3em'}} />
                        <Column columnKey="ShelfDTO.name" field="ShelfDTO.name" header="Name" sortable={true} />
                        <Column
                            columnKey="ShelfDTO.homeScreenShelf"
                            field="ShelfDTO.homeScreenShelf"
                            header="Home Screen Shelf"
                        />
                    </DataTable>
                </div>
            );
        }

        return null;
    }
}

reorderShelfList.propTypes = {
    cancelShelfOrder: PropTypes.func.isRequired,
    fetched: PropTypes.bool,
    fetching: PropTypes.bool,
    id: PropTypes.string.isRequired,
    lastLocation: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    shelvesData: PropTypes.object.isRequired,
    updateShelfOrder: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default withLastLocation(reorderShelfList);
